import React from "react";

function formatTime(sec) {
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
}

/**
 * Deliberately NOT a countdown-pressure timer. Shows elapsed time
 * quietly, and only surfaces a gentle nudge past 5 minutes — parent
 * decides whether to keep playing, no guilt language, no forced stop.
 */
export default function Timer({ elapsedSec, showNudge, onDismissNudge }) {
  return (
    <div className="flex items-center gap-1 text-xs sm:text-sm text-[#8B7FA8] font-medium">
      <span aria-hidden="true" className="text-lg lg:text-xl text-white">⏱️</span>
      <span className="text-lg lg:text-xl text-white">{formatTime(elapsedSec)}</span>
      {showNudge && (
        <div
          className="flex flex-col fixed inset-x-4 lg:w-72 bg-zinc-800 text-white rounded-2xl shadow-lg border border-[#F3EEFF] p-3 items-center gap-2 z-50"
          role="status"
        >
          <span className="text-xl" aria-hidden="true">🌟</span>
          <p className="text-lg lg:text-xl text-cyan-200 flex-1">
            Great play today! You've hit 5 minutes — a good spot to wrap up, or keep going if you're both having fun.
          </p>
          <button
            onClick={onDismissNudge}
            className="text-sm lg:text-lg w-fit font-semibold text-blue-800 px-2 py-1 rounded-full hover:bg-[#F3EEFF]"
          >
            Got it
          </button>
        </div>
      )}
    </div>
  );
}
